import React,{useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faUsers, faClock, faPlay, 
  faCheckCircle, faDatabase, faServer, 
 faChartLine, faCode, faProjectDiagram,
  faLaptopCode, faCertificate, faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';

const Oracle = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('Oracle Database');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New Oracle Certification</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">Oracle Database</span>
              </h1>
              <p className="hero-subtitle">
                Become an Oracle database expert with our comprehensive certification program. 
                Gain hands-on experience with SQL, PL/SQL, database administration, 
                and performance tuning for enterprise applications.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(5,500 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">30,000+</div>
                    <small className="text-muted">Certified Professionals</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">100 hours</div>
                    <small className="text-muted">Hands-on Labs</small>
                  </div>
                </div>
              </div>
              
              <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="subcourses-images/oracle.jpg" 
                  alt="Oracle Certification Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="course-details">
          <div className="course-content">
            {/* About Course */}
            <section className="about-course">
              <h2 className="section-title">About This Certification</h2>
              <p>This comprehensive Oracle certification program prepares you for database administration and development roles. You'll gain expertise in Oracle database architecture, SQL optimization, and PL/SQL programming used by Fortune 500 companies.</p>
              <p>Through real-world scenarios and hands-on labs, you'll build the skills needed to pass Oracle certifications and manage enterprise database systems.</p>
            </section>
            
            {/* Curriculum */}
            <section className="curriculum">
              <h2 className="section-title">Certification Path</h2>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 1: SQL Fundamentals</h3>
                <p>Master Oracle SQL for data manipulation and querying</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> SELECT statements</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Joins and subqueries</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data manipulation</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Built-in functions</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 2: PL/SQL Programming</h3>
                <p>Develop stored procedures and database logic</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> PL/SQL blocks</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Procedures & functions</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Packages</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Triggers</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 3: Database Administration</h3>
                <p>Manage Oracle database instances</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Installation & configuration</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> User management</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Backup & recovery</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Resource management</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faChartLine} className="me-2" /> Module 4: Performance Tuning</h3>
                <p>Optimize Oracle database performance</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> SQL tuning</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Index strategies</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Execution plans</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Memory management</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Advanced Features</h3>
                <p>Implement enterprise database solutions</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Partitioning</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data Guard</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> RAC</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cloud integration</div>
                </div>
              </div>
            </section>
          </div>  
          
          <div className="course-sidebar">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="info-content">
                <h4>Duration</h4>
                <p>12 Weeks (20 hrs/week)</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faCertificate} />
              </div>
              <div className="info-content">
                <h4>Certifications</h4>
                <p>Oracle Database SQL Certified</p>
                <p>Oracle PL/SQL Developer Certified</p>
                <p>Oracle DBA Certified</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faLaptopCode} />
              </div>
              <div className="info-content">
                <h4>Hands-on Labs</h4>
                <p>50+ Real-world Exercises</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="info-content">
                <h4>Prerequisites</h4>
                <p>Basic Database Concepts</p>
                <p>No Prior Oracle Knowledge Needed</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>
              <div className="info-content">
                <h4>Career Support</h4>
                <p>Resume Preparation</p>
                <p>DBA Interview Coaching</p>
              </div>
            </div>
            
            <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Oracle Database</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Oracle;